module.exports = __webpack_public_path__ + "img/113.efe0a0ea.jpg";